<script lang="ts">
//
  import { createEventDispatcher } from "svelte";

  export let isOpen = false;
  export let connected: boolean;

  const dispatch = createEventDispatcher();

  const close = (): void => {
    dispatch("close");
  };

  const formatDate = (date: Date): string => {
    return date.toISOString().split('T')[0]; // ISO format YYYY-MM-DD
  };

  const formatTime = (date: Date): string => {
    return date.toISOString().split('T')[1].split('.')[0]; // ISO time format HH:MM:SS
  };

  const now = new Date();
  const uptime = Math.floor((now.getTime() - performance.timeOrigin) / 1000);
  const formatUptime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
</script>

{#if isOpen}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div class="popup-overlay" on:click={close}>
    <div class="popup-content" on:click|stopPropagation>
      <header>
        <h2>Health Check</h2>
        <button class="close-btn" on:click={close}>×</button>
      </header>

      <div class="health-info">
        <div class="status-section">
          <h3>Connection Status</h3>
          <div class="status-item">
            <span class="label">WebSocket:</span>
            <span class="value" class:connected class:disconnected={!connected}>
              {connected ? "Connected" : "Disconnected"}
            </span>
          </div>
        </div>

        <div class="time-section">
          <h3>System Information</h3>
          <div class="status-item">
            <span class="label">Current Date:</span>
            <span class="value">{formatDate(now)}</span>
          </div>
          <div class="status-item">
            <span class="label">Current Time:</span>
            <span class="value">{formatTime(now)} UTC</span>
          </div>
          <div class="status-item">
            <span class="label">Session Uptime:</span>
            <span class="value">{formatUptime(uptime)}</span>
          </div>
        </div>

        <div class="app-section">
          <h3>Client</h3>
          <div class="status-item">
            <span class="label">User Agent:</span>
            <span class="value small">{navigator.userAgent}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.popup-content {
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #eee;
}

h2 {
  margin: 0;
  font-size: 1.2rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  background: #f8f9fa;
}

.health-info {
  padding: 1rem;
}

.status-section, .time-section, .app-section {
  margin-bottom: 1.5rem;
}

.status-section:last-child, .time-section:last-child, .app-section:last-child {
  margin-bottom: 0;
}

h3 {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f5f5f5;
}

.status-item:last-child {
  border-bottom: none;
}

.label {
  font-weight: 500;
  color: #555;
}

.value {
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  color: #333;
}

.value.small {
  font-size: 0.75rem;
  max-width: 60%;
  text-align: right;
  word-break: break-all;
}

.value.connected {
  color: #28a745;
  font-weight: 600;
}

.value.disconnected {
  color: #dc3545;
  font-weight: 600;
}
</style>
